/** API dependency rows that match the current install list (resourceId, resourceType, resourceSubtype). */
export function filterDependenciesForInstall(deps, installDeps) {
    return deps.filter(({ resourceId, resourceType, resourceSubtype }) => {
        return installDeps.some(({ resourceId: id, resourceType: type, resourceSubtype: subtype }) => {
            return id === resourceId
                && type === resourceType
                && subtype === resourceSubtype;
        });
    });
}
